// Can this browser reach the CloudPhone relay (TURN) right now?
//
// With "Always connect calls through the CloudPhone relay" on, a call may only
// use relay candidates. If the relay can't be reached, Chrome keeps gathering
// forever (seen in the lab: no candidate and still "gathering" after 60 s), so
// such a call would hang on "Calling…". The phone asks the relay once in the
// background (no microphone needed) and uses the normal path while it fails.

export const PROBE_TIMEOUT_MS = 4000;
/** how old a result may be before the next call checks again (in the background) */
export const PROBE_MAX_AGE_MS = 120_000;

/** True when a relay candidate arrives in time, false when none does. */
export async function relayReachable(iceServers: RTCIceServer[], timeoutMs = PROBE_TIMEOUT_MS): Promise<boolean> {
  if (typeof RTCPeerConnection === 'undefined') return false;
  let pc: RTCPeerConnection | null = null;
  try {
    pc = new RTCPeerConnection({ iceServers, iceTransportPolicy: 'relay' });
    const got = new Promise<boolean>((resolve) => {
      const timer = setTimeout(() => resolve(false), timeoutMs);
      pc!.onicecandidate = (e) => {
        if (e.candidate && / typ relay /.test(e.candidate.candidate)) {
          clearTimeout(timer);
          resolve(true);
        }
      };
    });
    pc.createDataChannel('probe');
    await pc.setLocalDescription(await pc.createOffer());
    return await got;
  } catch {
    return false;
  } finally {
    pc?.close();
  }
}
